import { Injectable } from '@angular/core';
import {
    HttpErrorResponse,
    HttpEvent,
    HttpHandler,
    HttpHeaders,
    HttpInterceptor,
    HttpRequest,
} from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError, finalize } from 'rxjs/operators';
import { LocalStorageJwtService } from './localstoragejwt.service';
import { STATUS_CODE } from '@core/constant';
import { AuthService } from 'app/modules/auth/data-access/services/auth.service';
@Injectable()
export class ServiceInterceptor implements HttpInterceptor {
    private readonly requests: HttpRequest<any>[] = [];
    constructor(
        private readonly jwtService: LocalStorageJwtService,
        private _authService: AuthService
    ) {}

    intercept(
        req: HttpRequest<any>,
        next: HttpHandler
    ): Observable<HttpEvent<any>> {
        const authToken = this.jwtService.getItem();
        // Build http request header
        let headers = req.headers;
        if (authToken) {
            headers = headers.append('Authorization', authToken);
        }

        if (req.url.includes('uploadOrder')) {
            headers = headers.append('Accept', '*/*');
        } else {
            headers = headers.append('Content-Type', 'application/json');
        }

        headers = this.setHeaderDatas(headers);
        const authReq = this.handleTriggerRequest(req, headers);

        this.requests.push(authReq);

        return next.handle(authReq).pipe(
            catchError((error: HttpErrorResponse) => {
                if (
                    error.status === STATUS_CODE.UNAUTHOR &&
                    error.statusText === 'Unauthorized'
                ) {
                    this._authService.logout(true).subscribe();
                }
                return throwError(error);
            }),
            finalize(() => {
                const index = this.requests.indexOf(authReq);
                if (index >= 0) {
                    this.requests.splice(index, 1);
                }
            })
        );
    }

    /**
     * Set header datas
     * @param headers dummy data
     */
    setHeaderDatas(headers: HttpHeaders): HttpHeaders {
        return headers;
    }

    handleTriggerRequest(req: any, headers: any): any {
        const urlCurrent = req.url;
        const apiCheck = /succeed=false/.test(urlCurrent);
        if (apiCheck) {
            const lastUrl = urlCurrent
                .split('?')
                .pop()
                .split('&')[0]
                .split('=')
                .pop();
            return req.clone({
                headers,
                url: `./assets/datas/${lastUrl}.json`,
                method: 'GET',
            });
        } else {
            return req.clone({ headers, Credential: true });
        }
    }

    handleHeader(req: HttpRequest<any>): void {
        const header = req.headers;
    }
}
